export { devServer as default } from '../lib/middleware/dev-server.js';
